import styled from "styled-components";
import { AutoplaySettingButton } from "../../../../../ui/AutoplaySettingButton";

export const SettingButton = styled(AutoplaySettingButton)`
  margin: 0.4em 0.5em;
  padding: 0.32em 0.4em 0.5em;
  flex: 1 0 20%;
  max-width: 23.6%;
`;

export const ResetButton = styled(SettingButton)`
  margin: 2em auto;
  text-transform: uppercase;
  border-width: 0.1em;
  display: block;
  max-width: 50%;
`;
